import { useEffect } from "react";
import Nav from "@/components/landing/Nav";
import Footer from "@/components/landing/Footer";

export default function LegalLayout({ title, updated, children, testId }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main data-testid={testId} className="bg-[#FDFCFB] min-h-screen">
      <Nav />
      <section className="pt-32 md:pt-40 pb-24">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-neutral-500">5ads.ai — Legal</p>
          <h1 className="font-heading font-semibold tracking-tighter text-4xl md:text-5xl text-neutral-900 mt-4">
            {title}
          </h1>
          <p className="text-sm text-neutral-500 mt-3">Last updated: {updated}</p>
          <div className="mt-10 space-y-10">{children}</div>
        </div>
      </section>
      <Footer />
    </main>
  );
}

export function LegalSection({ heading, children, id }) {
  return (
    <div id={id}>
      <h2 className="font-heading text-xl md:text-2xl font-medium text-neutral-900">{heading}</h2>
      <div className="text-neutral-600 leading-relaxed mt-3 space-y-3 text-sm md:text-base">{children}</div>
    </div>
  );
}
